const asyncPipe = fns => starterValue => fns.reduce(async (result, nextFunc) => {
  const response = nextFunc(await result);
  return response;
}, starterValue);

// Another option without async/await
// const asyncPipe = fns => arg => fns.reduce((p, f) => p.then(f), Promise.resolve(arg));

export default asyncPipe;
